import type { IconNode } from '../types';

/**
 * @name sunlounger-parasol-sun-palmtree
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTYgMTRzMS0zIDEtOFY0cy0xLTItMy0yYy0xIDAtMiAuNS0yIC41IiAvPgogIDxwYXRoIGQ9Ik0xMyA4YTQgNCAwIDAgMSA4IDAiIC8+CiAgPHBhdGggZD0iTTE3IDRzMS0yIDMtMmMxIDAgMiAuNSAyIC41IiAvPgogIDxwYXRoIGQ9Im00IDE0IDMtNSA1IDNaIiAvPgogIDxwYXRoIGQ9Im04IDEzIDIgOCIgLz4KICA8cGF0aCBkPSJtMyAyMSAuNy0yLjFjLjItLjUuNy0uOSAxLjMtLjloMTJjLjUgMCAxLjMtLjQgMS42LS44TDIyIDEzIiAvPgogIDxwYXRoIGQ9Im0yMSAyMS0zLTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/sunlounger-parasol-sun-palmtree
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sunloungerParasolSunPalmtree: IconNode = [
  ['circle', { cx: '4', cy: '4', r: '2', key: 'bt5ra8' }],
  ['path', { d: 'M16 14s1-3 1-8V4s-1-2-3-2c-1 0-2 .5-2 .5', key: '1kv3wi' }],
  ['path', { d: 'M13 8a4 4 0 0 1 8 0', key: 'lrfcfp' }],
  ['path', { d: 'M17 4s1-2 3-2c1 0 2 .5 2 .5', key: '8sabee' }],
  ['path', { d: 'm4 14 3-5 5 3Z', key: 'ejj0tt' }],
  ['path', { d: 'm8 13 2 8', key: 'afmlpj' }],
  ['path', { d: 'm3 21 .7-2.1c.2-.5.7-.9 1.3-.9h12c.5 0 1.3-.4 1.6-.8L22 13', key: '12dkjb' }],
  ['path', { d: 'm21 21-3-3', key: 'wjr3av' }],
];

export default sunloungerParasolSunPalmtree;
